






















































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "ThreatGeoDashboard",
})
export default class ThreatGeoDashboard extends Vue {
  @Prop({ default: () => [] }) ranking!: any[];
  @Prop({ default: () => [] }) history!: any[];
  @Prop({ default: 0 }) totalThreats!: number;
  @Prop({ default: 0 }) blockedIpsCount!: number;

  // Mapa de coordenadas aproximadas para el SVG simplificado
  private countryCoords: Record<string, { x: number; y: number }> = {
    RU: { x: 680, y: 120 },
    CN: { x: 750, y: 220 },
    US: { x: 220, y: 210 },
    USA: { x: 220, y: 210 },
    BR: { x: 340, y: 380 },
    ES: { x: 480, y: 190 },
    DE: { x: 520, y: 160 },
    GB: { x: 490, y: 140 },
    UK: { x: 490, y: 140 },
    FR: { x: 495, y: 175 },
    IT: { x: 520, y: 195 },
    AU: { x: 850, y: 400 },
    NL: { x: 505, y: 155 },
    CA: { x: 200, y: 120 },
    IN: { x: 700, y: 280 },
  };

  // Datos calculados para el Dashboard
  public get uniqueCountries(): number {
    if (!this.ranking || !Array.isArray(this.ranking)) return 0;
    const countries = new Set(
      this.ranking.map((r) => r.country).filter(Boolean)
    );
    return countries.size || 0;
  }

  public get wafDetections(): number {
    if (!this.history || !Array.isArray(this.history)) return 0;
    return this.history.filter(
      (h) =>
        h.path &&
        (h.path.includes("WAF") ||
          h.path.includes("SQL") ||
          h.path.includes("XSS"))
    ).length;
  }

  public get rateDetections(): number {
    if (!this.history || !Array.isArray(this.history)) return 0;
    return this.history.filter((h) => h.path && h.path.includes("Rate Limit"))
      .length;
  }

  public get honeypotDetections(): number {
    if (!this.history || !Array.isArray(this.history)) return 0;
    return this.history.filter((h) => h.path && h.path.includes("Honeypot"))
      .length;
  }

  // Generar puntos de ataque dinámicos basados en la IP Ranking
  public get mapAttacks() {
    if (!this.ranking || !Array.isArray(this.ranking)) return [];

    return this.ranking
      .map((r) => {
        const countryMatch = r.country
          ? r.country.match(/\(([A-Z]{2})\)/)
          : null;
        const code = countryMatch ? countryMatch[1] : null;
        const coords = code ? this.countryCoords[code] : null;

        if (coords) {
          return {
            country: r.country,
            x: coords.x,
            y: coords.y,
            intensity: r.threat_score,
            color: this.getScoreColor(r.threat_score),
            count: 1, // O usar un contador si la API lo diera
          };
        }
        return null;
      })
      .filter(Boolean);
  }

  // Top Orígenes dinámicos
  public get topOrigins() {
    if (!this.ranking || !Array.isArray(this.ranking)) return [];

    const countryCounts: Record<string, number> = {};
    this.ranking.forEach((r) => {
      if (r.country) {
        countryCounts[r.country] = (countryCounts[r.country] || 0) + 1;
      }
    });

    const total = Object.values(countryCounts).reduce((a, b) => a + b, 0);

    return Object.entries(countryCounts)
      .map(([country, count]) => ({
        country,
        count,
        percentage: total > 0 ? Math.round((count / total) * 100) : 0,
        color: this.getCountryColor(country),
        risk: count > 10 ? "Alto" : "Medio",
      }))
      .sort((a, b) => b.count - a.count)
      .slice(0, 5);
  }

  // Eventos recientes reales
  public get recentEvents() {
    if (!this.history || !Array.isArray(this.history)) return [];

    return this.history.slice(0, 5).map((h) => ({
      title: this.getViolationTitle(h.path),
      ip: h.ip_address,
      country: h.country || "N/A",
      time: this.formatTimeAgo(h.timestamp),
      icon: this.getViolationIcon(h.path),
      color: this.getViolationColor(h.path),
      action: "DETECTADO",
    }));
  }

  private getScoreColor(score: number): string {
    if (score > 85) return "#D32F2F";
    if (score > 60) return "#FF5252";
    if (score > 30) return "#FB8C00";
    return "#2196F3";
  }

  private getCountryColor(country: string): string {
    if (country.includes("RU") || country.includes("CN")) return "error";
    return "warning";
  }

  private getViolationTitle(path: string): string {
    if (!path) return "Actividad Sospechosa";
    if (path.includes("Honeypot")) return "Intrusión Honeypot";
    if (path.includes("Failed Login")) return "Ataque de Fuerza Bruta";
    if (path.includes("WAF") || path.includes("SQL"))
      return "Explotación Vulnerabilidad";
    return "Violación de Política";
  }

  private getViolationIcon(path: string): string {
    if (path && path.includes("Honeypot")) return "mdi-honey-pot";
    if (path && path.includes("Failed Login")) return "mdi-lock-reset";
    return "mdi-shield-alert";
  }

  private getViolationColor(path: string): string {
    if (path && (path.includes("Honeypot") || path.includes("SQL")))
      return "error";
    return "warning";
  }

  private formatTimeAgo(timestamp: string): string {
    if (!timestamp) return "Reciente";
    const date = new Date(timestamp);
    const now = new Date();
    const diff = Math.floor((now.getTime() - date.getTime()) / 60000);
    if (diff < 1) return "Justo ahora";
    if (diff < 60) return `Hace ${diff} min`;
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  }

  public getPulseSize(intensity: number): number {
    return 6 + (intensity / 100) * 10;
  }
}
